//# sourceMappingURL=my-month-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-month-labels.interface.js
// module id = 756
// module chunks = 3